import { useEffect, useState } from "react";

const links = [
  { href: "#hot", label: "焦点速览" },
  { href: "#timeline", label: "本月时间线" },
  { href: "#guide", label: "内容导览" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于本站" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b border-background-200/80 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 shadow-sm backdrop-blur" : "bg-background-50/70"
      }`}
    >
      <div className="container-x flex items-center justify-between py-3">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-foreground-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950">
            本月大瓜<span className="text-primary-500">时间线</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#contact"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-foreground-50 transition-colors hover:bg-primary-600"
          >
            反馈线索
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-800 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-foreground-50 hover:bg-primary-600"
            >
              反馈线索
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}